import * as utility from "/assets/src/js/theme/helpers.js";

( function($) {

    /**
     * Inline script data from WordPress
     * - Defined in child theme functions.php
     * =================
     * 
     * Info: Path urls for our website
     * Var: const wordpress
     * @type {Object}
     * 
     */

    //Wait for DOM to load completely before running code
    //-- Support for Avada live builder
    window.addEventListener('DOMContentLoaded', function() {
        
    });

})(jQuery);